import request from '../utils/request';

// 分页查询陪逛服务订单
export const listAccompanyShoppingOrders = (params) => {
  return request({
    url: '/accompany-shopping-order/list',
    method: 'get',
    params
  });
};

// 查询服务提供者的陪逛服务订单
export const listProviderAccompanyShoppingOrders = (providerId, params) => {
  return request({
    url: `/accompany-shopping-order/provider/${providerId}`,
    method: 'get',
    params
  });
};

// 查询单个陪逛服务订单详情
export const getAccompanyShoppingOrderById = (id) => {
  return request({
    url: `/accompany-shopping-order/${id}`,
    method: 'get'
  });
};

// 更新陪逛服务订单状态
export const updateAccompanyShoppingOrderStatus = (orderId, status) => {
  return request({
    url: '/accompany-shopping-order/status',
    method: 'put',
    params: { orderId, status }
  });
};

// 更新陪逛服务订单信息
export const updateAccompanyShoppingOrder = (orderData) => {
  return request({
    url: '/accompany-shopping-order/update',
    method: 'put',
    data: orderData
  });
}; 